var states = [
    {
        name: "United Kingdom",
        id: "GBR"
    },
    {
        name: "Ireland",
        id: "IRL"
    },
];
export default states;
